// Blocks operator-portal accounts from staff-only V2 routes (COL-352) —
// the route-level twin of OPERATOR_CONSOLE_TABS, mirroring FeatureFlagGate's
// redirect shape. Waits on rolesReady so a hard load never bounces a staff
// user whose roles are still resolving (the COL-255 lesson).
import type { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

export function OperatorRouteGate({ children }: { children: ReactNode }) {
  const { loading, rolesReady, user, isOperatorPortal } = useAuth();
  if (loading || (user && !rolesReady)) return null;
  if (isOperatorPortal) return <Navigate to="/admin?tab=analytics" replace />;
  return <>{children}</>;
}
